/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuoteSummaryDto } from './QuoteSummaryDto';
import {
    QuoteSummaryDtoFromJSON,
    QuoteSummaryDtoFromJSONTyped,
    QuoteSummaryDtoToJSON,
    QuoteSummaryDtoToJSONTyped,
} from './QuoteSummaryDto';

/**
 * 
 * @export
 * @interface GetQuoteListResponseDto
 */
export interface GetQuoteListResponseDto {
    /**
     * 
     * @type {number}
     * @memberof GetQuoteListResponseDto
     */
    totalCount: number;
    /**
     * 
     * @type {Array<QuoteSummaryDto>}
     * @memberof GetQuoteListResponseDto
     */
    items: Array<QuoteSummaryDto>;
}

/**
 * Check if a given object implements the GetQuoteListResponseDto interface.
 */
export function instanceOfGetQuoteListResponseDto(value: object): value is GetQuoteListResponseDto {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetQuoteListResponseDtoFromJSON(json: any): GetQuoteListResponseDto {
    return GetQuoteListResponseDtoFromJSONTyped(json, false);
}

export function GetQuoteListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQuoteListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(QuoteSummaryDtoFromJSON)),
    };
}

export function GetQuoteListResponseDtoToJSON(json: any): GetQuoteListResponseDto {
    return GetQuoteListResponseDtoToJSONTyped(json, false);
}

export function GetQuoteListResponseDtoToJSONTyped(value?: GetQuoteListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(QuoteSummaryDtoToJSON)),
    };
}

